import React, { useEffect } from 'react'

import {
  ButtonStyle,
  ConfirmationModal,
  ModalActionTypes,
} from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'

import {
  trackTwoFactorAuthPhoneNumberDisabledModalHelpTappedPayload,
  trackTwoFactorAuthPhoneNumberDisabledModalTryAgainTappedPayload,
  trackTwoFactorAuthPhoneNumberDisabledModalViewedPayload,
} from 'generated/trackingEvents'

type Props = {
  isExceptionModalOpen: boolean
  handleCloseExceptionModal: () => void
}

export const PhoneNumberOptedOutExceptionModal = (props: Props) => {
  const { track } = useAnalyticsClient()

  const handleTryAgain = () => {
    track(
      ...trackTwoFactorAuthPhoneNumberDisabledModalTryAgainTappedPayload({
        screen: 'login',
      }),
    )
    props.handleCloseExceptionModal()
  }

  const handleContactCustomerSupport = () => {
    window.open('https://support.acorns.com/hc/en-us/requests/new', '_blank')
    track(
      ...trackTwoFactorAuthPhoneNumberDisabledModalHelpTappedPayload({
        screen: 'login',
      }),
    )
  }

  useEffect(() => {
    if (props.isExceptionModalOpen) {
      track(
        ...trackTwoFactorAuthPhoneNumberDisabledModalViewedPayload({
          screen: 'login',
        }),
      )
    }
  }, [props.isExceptionModalOpen, track])

  return (
    <ConfirmationModal
      isOpen={props.isExceptionModalOpen}
      buttonStyle={ButtonStyle.column}
      actions={[
        {
          handler: handleContactCustomerSupport,
          label: 'Contact Customer Support',
          type: ModalActionTypes.secondary,
        },
        {
          handler: handleTryAgain,
          label: 'Try Again',
          type: ModalActionTypes.primary,
        },
      ]}
      title="Text verification disabled"
      message={
        <>
          Your phone number is currently opted out of SMS two-factor
          authentication. To re-enable, text <strong>START</strong> to{' '}
          <strong>50961</strong> or contact support.
        </>
      }
    />
  )
}
